import { Context } from '@nuxt/types'

// .. Fire redirect with correct redirect code
export default function redirect(redirectTo?: string) {
  return (context: Context) => {
    const goto = redirectTo ?? '/'
    context.redirect(301, goto)
  }
}
